module.exports = __webpack_public_path__ + "img/nf.nf7988830.svg";